const listeners = new Set();
const errorIds = new WeakMap();
let sequence = 0;
const nextId = () => (typeof crypto !== "undefined" ? crypto.randomUUID?.() : null) || `${Date.now()}-${++sequence}`;

export function getErrorDetails(error) {
  const data = error?.response?.data;
  const message = typeof data === "string"
    ? data
    : data?.detail || data?.message || (typeof data?.error === "string" ? data.error : "");
  return [error?.response?.status && `HTTP ${error.response.status}`, message || error?.message]
    .filter(Boolean).join("\n").slice(0, 4000);
}

export function reportError(error, message) {
  let id;
  if (error && typeof error === "object") {
    id = errorIds.get(error) || nextId();
    errorIds.set(error, id);
  }
  const status = error?.response?.status;
  const fallback = status === 403
    ? "No tienes permiso para realizar esta acción. Contacta a quien administra tu organización."
    : status === 401
    ? "Tu sesión ha vencido. Inicia sesión de nuevo para continuar."
    : !error?.response && error?.isAxiosError
    ? "No pudimos conectar con el servidor. Revisa tu conexión e inténtalo de nuevo."
    : "No se pudo completar la operación. Inténtalo de nuevo; si el problema continúa, contacta al administrador.";
  pushError(message || fallback, { ...(id ? { id } : {}), detail: getErrorDetails(error) });
}

export function pushError(message, options = {}) {
  const payload = {
    id: nextId(),
    message: message || "No se pudo completar la operación. Inténtalo de nuevo o contacta al administrador.",
    ...options, // { title?, autoCloseMs? }
  };
  for (const fn of listeners) {
    try { fn(payload); } catch {}
  }
}

export function subscribeErrors(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
